import gql from 'graphql-tag';

export const getCurrentParkingInventory = gql`
  query getCurrentParkingInventory($facilityId: ID!, $first: Int, $skip: Int, $entryDateFrom: String) {
    getCurrentParkingInventory(facilityId: $facilityId, first: $first, skip: $skip, entryDateFrom: $entryDateFrom) {
      items {
        plate
        entryTime
        entryGate
        duration
        parkingType
      }
      totalCount
    }
  }
`;

export const markCarAsExited = gql`
  mutation markCarAsExited($facilityId: ID!, $plate: String!, $exitTime: String) {
    markCarAsExited(facilityId: $facilityId, plate: $plate, exitTime: $exitTime) {
      id
      plate
      createdAt
      gate {
        id
        gateDescription
        type
      }
    }
  }
`;

export const getMostRecentEntryDate = gql`
  query getMostRecentEntryDate($facilityId: ID!) {
    getMostRecentEntryDate(facilityId: $facilityId)
  }
`;
